export const COUNTRY_TELEPHONE_PREFIX = {
    VIETNAM: '+84',
    THAILAND: '+66',
    CAMBODIA: '+855'
};